module.exports = __webpack_public_path__ + "img/040-hoodie.5af51da3.png";